import React from "react";
import { connect } from "react-redux";
import { setCustomerBillingAddressId } from "../redux/actions";
import AddressSelect from "./AddressSelect";
import { Col, Form, Row } from "react-bootstrap";

function QuoteBillingInformation({
  customerBillingAddressId,
  setCustomerBillingAddressId
}) {
  return (
    <Form.Group as={Row} controlId="billing">
      <Form.Label sm={2} column>
        Billing Address
      </Form.Label>

      <Col sm={10}>
        <AddressSelect
          addressId={customerBillingAddressId}
          onAddressIdChange={setCustomerBillingAddressId}
        />
      </Col>
    </Form.Group>
  );
}

export default connect(
  state => ({
    customerBillingAddressId: state.quote.customerBillingAddressId
  }),
  { setCustomerBillingAddressId }
)(QuoteBillingInformation);
